import styles from './style.module.scss';

/** Shimmer placeholder held in place while the subscription request is in flight. */
export default function PlanSkeleton() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.header} />
            <div className={styles.plan_box} />
            <div className={styles.actions}>
                <div className={styles.button} />
                <div className={styles.button} />
            </div>
        </div>
    );
};
